<template>
  <b-modal
    id="requestConfirmationModal"
    ref="requestConfirmationModal"
    hide-footer
    hide-header
    centered
    size="sm"
    body-class="strm-body"
  >
    <div class="strm">
      <div class="strm-icon">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h3 class="strm-title">Solicitação enviada!</h3>
      <p v-if="timeSuggestion" class="strm-text">
        Seu interesse foi registrado.
        <br />
        <strong>Aguarde a confirmação</strong>
        do profissional de saúde via WhatsApp para
        <strong>{{ formattedDate }}</strong>
        .
      </p>
      <button type="button" class="strm-btn" @click="confirmRequest">
        Entendido
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { parseISO, format } from "date-fns";
import { pt as locale } from "date-fns/locale";

export default {
  name: "ScheduleTableRequestModal",
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    confirmRequest() {
      this.$bvModal.hide("requestConfirmationModal");
      this.$router.push({ name: "Schedule" });
    }
  },
  computed: {
    ...mapGetters("slot", ["timeSuggestion"]),

    formattedDate() {
      return format(
        parseISO(this.timeSuggestion),
        "EEEE, dd 'de' MMMM', às ' HH:mm",
        { locale }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.strm {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--space-6, 24px) var(--space-4, 16px) var(--space-4, 16px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
}

.strm-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--color-success-light, #dcfce7);
  color: var(--color-success, #16a34a);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--space-4, 16px);
}

.strm-title {
  font-size: var(--font-size-lg, 1.125rem);
  font-weight: var(--fw-bold, 700);
  color: var(--color-gray-900, #0f172a);
  margin: 0 0 var(--space-3, 12px);
}

.strm-text {
  font-size: var(--font-size-sm, 0.875rem);
  color: var(--color-gray-600, #475569);
  line-height: 1.6;
  margin: 0 0 var(--space-5, 20px);
}

.strm-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: var(--radius-md, 8px);
  background: var(--color-primary, #1a6cf7);
  color: #fff;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--fw-bold, 700);
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--color-primary-dark, #1352c4);
  }
}
</style>

<style>
.strm-body {
  padding: 0 !important;
}
</style>
